export default "__VITE_ASSET__CZ6BtscW__"